// import React from "react";
// import { Flex, Spin } from "antd";
// import PatientListItem from "./PatientListItem";

// function ConversedPatientsList({
//   patients,
//   isLoading,
//   unreadCounts,
//   onSelectPatient,
//   onOpenAllPatients,
//   onSearchChange,
// }) {
//   return (
//     <div className="w-full max-w-sm mx-auto bg-white shadow-lg rounded-lg">
//       <div className="flex items-center p-4 border-b">
//         <button className="text-gray-500 bg-white" onClick={onOpenAllPatients}>
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M4 6h16M4 12h16m-7 6h7"
//             ></path>
//           </svg>
//         </button>
//         <input
//           type="text"
//           placeholder="Search"
//           onChange={onSearchChange}
//           className="ml-4 flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
//         />
//       </div>

//       <div>
//         {isLoading && patients.length === 0 ? (
//           <div className="h-screen flex items-center justify-center">
//             <Flex align="center" gap="middle">
//               <Spin size="large" tip="Loading" />
//             </Flex>
//           </div>
//         ) : !isLoading && patients.length === 0 ? (
//           <div className="h-screen flex flex-col gap-1 justify-center items-center">
//             <p className="text-lg font-light">No conversations.</p>
//           </div>
//         ) : (
//           patients.map((patient) => (
//             <PatientListItem
//               key={patient.patientId}
//               patient={patient}
//               unreadCount={unreadCounts[patient.patientId]}
//               onClick={() => onSelectPatient(patient)}
//             />
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// export default ConversedPatientsList;

import React from "react";
import { Flex, Spin } from "antd";
import PatientListItem from "./PatientListItem";

function ConversedPatientsList({
  patients,
  isLoading,
  error,
  unreadCounts,
  searchTerm,
  isSearching,
  onSelectPatient,
  onSearchChange,
  onClearSearch,
}) {
  return (
    <div className="w-full max-w-sm mx-auto bg-white shadow-lg rounded-lg">
      <div className="flex items-center gap-2 p-4 border-b">
        <div className="relative flex-1">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={onSearchChange}
            className="w-full pl-4 pr-8 py-2 rounded-full bg-gray-100 outline-none"
          />
          {searchTerm && (
            <button
              onClick={onClearSearch}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 bg-slate-100"
              aria-label="Clear search"
            >
              ×
            </button>
          )}
        </div>
      </div>

      <div>
        {error && <p className="text-center text-sm text-red-500 py-2">{error}</p>}

        {isLoading ? (
          <div className="h-screen flex items-center justify-center">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : patients.length === 0 ? (
          <div className="h-screen flex flex-col gap-1 justify-center items-center">
            <p className="text-lg font-light">
              {isSearching ? "No patients found." : "No conversations."}
            </p>
          </div>
        ) : (
          patients.map((patient) => (
            <PatientListItem
              key={patient.patientId}
              patient={patient}
              unreadCount={unreadCounts[patient.patientId]}
              onClick={() => onSelectPatient(patient)}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default ConversedPatientsList;